import {useCallback} from "react";

import {hitGTMEcommerceRemoveFromCart} from "../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_remove_from_cart";
import {useAppSelector} from "../../store/hooks";
import {gtmStepApplicationClose} from "../../tracking/google_tag_manager/gtm_event_step_application_close";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {trackAmplitudeLeadFormClose} from "../tracking/amplitude/track_amplitude_lead_form_events";
import {useLeadData} from "./use_lead_data";
import {LeadFormCloseSnapshotRef} from "./use_lead_form_close_snapshot_ref";
import {useLeadRequiredParams} from "./use_lead_required_params";

export function useLeadFormCloseTracking(handleModalClose: (forceClose?: boolean) => void, formCloseSnapshotRef?: LeadFormCloseSnapshotRef) {
    const {vendorId, offerId, propertyId, source} = useLeadRequiredParams();
    const applicationData = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined});
    const viewType = useAppSelector((state) => state.viewType.current);
    const mainLeadType = useAppSelector((state) => state.mainLead.mainLeadType);
    const amplitudeLeadFormEventTracking = useAppSelector((state) => state.mainLead.amplitudeLeadFormEventTracking);
    const sourceSection = useAppSelector((state) => state.mainLead.sourceSection);
    const customSourceSection = useAppSelector((state) => state.mainLead.customSourceSection);
    const {data: userProfile} = useGetUserProfileQuery();

    const resolvedSourceSection = customSourceSection || sourceSection;

    return useCallback(
        (forceClose?: boolean) => {
            if (amplitudeLeadFormEventTracking && applicationData && sourceSection != null) {
                const hasAutofill = !!(userProfile?.name || userProfile?.email || userProfile?.phone);

                trackAmplitudeLeadFormClose({
                    trackingContext: amplitudeLeadFormEventTracking,
                    leadData: applicationData,
                    source,
                    sourceSection,
                    formSnapshot: formCloseSnapshotRef?.current?.(),
                    ...(hasAutofill ? {eventAction: "autofill"} : {})
                });
            }

            if (mainLeadType && applicationData) {
                gtmStepApplicationClose(mainLeadType);

                if (resolvedSourceSection) {
                    hitGTMEcommerceRemoveFromCart({
                        data: applicationData,
                        viewType,
                        leadType: mainLeadType,
                        sourceSection: resolvedSourceSection
                    });
                }
            }

            handleModalClose(forceClose);
        },
        [
            amplitudeLeadFormEventTracking,
            applicationData,
            formCloseSnapshotRef,
            handleModalClose,
            mainLeadType,
            resolvedSourceSection,
            source,
            sourceSection,
            userProfile,
            viewType
        ]
    );
}
import {useCallback} from "react";

import {hitGTMEcommerceRemoveFromCart} from "../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_remove_from_cart";
import {useAppSelector} from "../../store/hooks";
import {gtmStepApplicationClose} from "../../tracking/google_tag_manager/gtm_event_step_application_close";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {trackAmplitudeLeadFormClose} from "../tracking/amplitude/track_amplitude_lead_form_events";
import {useLeadData} from "./use_lead_data";
import {LeadFormCloseSnapshotRef} from "./use_lead_form_close_snapshot_ref";
import {useLeadRequiredParams} from "./use_lead_required_params";

export function useLeadFormCloseTracking(handleModalClose: (forceClose?: boolean) => void, formCloseSnapshotRef?: LeadFormCloseSnapshotRef) {
    const {vendorId, offerId, propertyId, source} = useLeadRequiredParams();
    const applicationData = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined});
    const viewType = useAppSelector((state) => state.viewType.current);
    const mainLeadType = useAppSelector((state) => state.mainLead.mainLeadType);
    const amplitudeLeadFormEventTracking = useAppSelector((state) => state.mainLead.amplitudeLeadFormEventTracking);
    const sourceSection = useAppSelector((state) => state.mainLead.sourceSection);
    const customSourceSection = useAppSelector((state) => state.mainLead.customSourceSection);
    const {data: userProfile} = useGetUserProfileQuery();

    const resolvedSourceSection = customSourceSection || sourceSection;

    return useCallback(
        (forceClose?: boolean) => {
            if (amplitudeLeadFormEventTracking && applicationData && sourceSection != null) {
                const hasAutofill = !!(userProfile?.name || userProfile?.email || userProfile?.phone);

                trackAmplitudeLeadFormClose({
                    trackingContext: amplitudeLeadFormEventTracking,
                    leadData: applicationData,
                    source,
                    sourceSection,
                    formSnapshot: formCloseSnapshotRef?.current?.(),
                    ...(hasAutofill ? {eventAction: "autofill"} : {})
                });
            }

            if (mainLeadType && applicationData) {
                gtmStepApplicationClose(mainLeadType);

                if (resolvedSourceSection) {
                    hitGTMEcommerceRemoveFromCart({
                        data: applicationData,
                        viewType,
                        leadType: mainLeadType,
                        sourceSection: resolvedSourceSection
                    });
                }
            }

            handleModalClose(forceClose);
        },
        [
            amplitudeLeadFormEventTracking,
            applicationData,
            formCloseSnapshotRef,
            handleModalClose,
            mainLeadType,
            resolvedSourceSection,
            source,
            sourceSection,
            userProfile,
            viewType
        ]
    );
}
